import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/answer/configuration/AnswerConfiguration.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/answer/v1/configs`;
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, e));
	}
	create(e) {
		return this.api.post(n.baseUrl, { name: e });
	}
	edit(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, { name: t });
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
};
export { n as AnswerConfigurationResource };

//# sourceMappingURL=AnswerConfiguration.js.map